
export class ClientDocumento {
  id?: number;
  nome?: string;
  mimeType?: string;
  tamanho?: number;
  dataUpload?: string;
}

export class Client {
    id: number;
    nomeFantasia: string;
    address: string;
    block: string;
    batch: string;
    telephone: string;
    complement: string;
    observation: string;
    neighborhood: string;
    city: string;
    seller: string;
    documento: string;
    plano: string;
    planoId: number;
    razaoSocial: string;
    ativo: boolean;
    whatsapp: string;
    email: string;
    cep: string;
    estado: string;
    bairro: string;
    pessoaContato: string;
    contato: string;
    carencia: number;
    diaVencimento: number;
    tenantId: string;
    importadoWowve: boolean;
    segmentos?: string[];
    planosSegmento?: { segmento: string; plano: string; planoId: number; diaVencimento: number; carencia: number; colaboradorId?: number | null; colaboradorNome?: string | null }[];
    clientePagadorId?: number;
    clientePagadorNome?: string;
    documentos?: ClientDocumento[];

    constructor(id: number, nomeFantasia: string, address: string, block: string, batch: string, telephone: string, complement: string, observation: string,
        neighborhood: string, city: string, seller: string, documento: string, plano: string, itemPlano: number, razaoSocial: string, ativo: boolean,
        whatsapp: string, email: string, cep: string, estado: string, bairro: string, pessoaContato: string, contato: string, carencia: number, diaVencimento: number , tenantId: string, importadoWowve: boolean) {
        this.id = id;
        this.nomeFantasia = nomeFantasia;
        this.address = address;
        this.block = block;
        this.batch = batch;
        this.telephone = telephone;
        this.complement = complement;
        this.observation = observation;
        this.neighborhood = neighborhood;
        this.city = city;
        this.seller = seller;
        this.documento = documento;
        this.plano = plano;
        this.planoId = itemPlano;
        this.razaoSocial = razaoSocial;
        this.ativo = ativo;
        this.whatsapp = whatsapp;
        this.email = email;
        this.cep = cep;
        this.estado = estado;
        this.bairro = bairro;
        this.pessoaContato = pessoaContato;
        this.contato = contato;
        this.carencia = carencia;
        this.diaVencimento = diaVencimento;
        this.tenantId = tenantId;
        this.importadoWowve = importadoWowve
    }
}